import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot } from "vue"

import useOwnerOfJurisdiction from '../../composables/useOwnerOfJurisdiction/useOwnerOfJurisdiction';
import { toRef } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  product: {
    type: String,
    required: true,
  },
  location: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props



const isOwner = useOwnerOfJurisdiction(toRef(props, 'product'), toRef(props, 'location'));

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", { isOwner: _unref(isOwner) })
}
}

})